import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Arrow Up"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-arrow-up',
    templateUrl: './icon-arrow-up.component.html',
    styleUrls: ['./icon-arrow-up.component.scss'],
    standalone: false
})
export class IconArrowUpComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
